import bbox from "@turf/bbox";
import transformScale from "@turf/transform-scale";
import type { LngLatBoundsLike } from "maplibre-gl";
import type { GeoJSONStoreFeatures } from "terra-draw";
import type { Coordinates } from "./types";

/** A polygon needs at least three points to enclose an area. */
export function isPolygon(coordinates: Coordinates) {
  return coordinates.length >= 3;
}

export function coordinatesToFeature(
  coordinates: Coordinates,
): GeoJSONStoreFeatures {
  return {
    id: globalThis.crypto.randomUUID(),
    type: "Feature",
    geometry: {
      type: "Polygon",
      coordinates: [coordinates],
    },
    properties: {
      mode: "polygon",
    },
  };
}

export function coordinatesToMapBounds(coordinates: Coordinates) {
  return bbox(
    transformScale(coordinatesToFeature(coordinates), 1.2),
  ) as LngLatBoundsLike;
}
